import { Box, Typography } from "@mui/material"
import type { FC } from "react"
import { FileIcon } from "shared/assets/icons/FileIcon"

interface QuoteEmailAttachmentCardProps {
  filename: string
  signedUrl: string
}

export const QuoteEmailAttachmentCard: FC<QuoteEmailAttachmentCardProps> = ({ filename, signedUrl }) => (
  <Box
    component='a'
    href={signedUrl}
    target='_blank'
    rel='noreferrer'
    className='flex w-[175px] flex-col gap-2 border border-gray-400 bg-gray-100 p-1 no-underline'
    data-testid='sales.email-preview.attachment'
  >
    <Box className='relative h-[90px] overflow-hidden bg-white'>
      <Box
        component='embed'
        src={`${signedUrl}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
        type='application/pdf'
        className='pointer-events-none size-full'
        data-testid='sales.email-preview.attachment-preview'
      />
    </Box>
    <Box className='flex items-center gap-2 px-1'>
      <FileIcon type='pdf' className='h-5 w-4 shrink-0' />
      <Typography className='truncate text-xs text-gray-900'>{filename}</Typography>
    </Box>
  </Box>
)
